import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  fr: {
    "nav.services": "Services", "nav.pricing": "Tarifs", "nav.fleet": "Flotte", "nav.reviews": "Avis",
    "nav.contact": "Contact", "nav.book": "Réserver",
    "widget.overline": "Réservation express", "widget.title": "Votre course en 2 minutes",
    "widget.pickup": "Adresse de départ", "widget.dropoff": "Adresse de destination", "widget.date": "Date", "widget.time": "Heure",
    "widget.submit": "Voir le prix & réserver",
    "widget.note": "Prix fixe garanti avant réservation — sans compte, sans engagement.",
    "widget.quote_link": "Autre adresse ? Devis gratuit",
    "widget.err_locations": "Choisissez deux lieux différents.",
    "hero.overline": "Chauffeur privé — Nice · Cannes · Monaco",
    "hero.l1": "Votre chauffeur privé,", "hero.l2": "sur la Côte d'Azur.", "hero.l3": "Prix fixe. Sans attente.",
    "hero.subtitle": "Transferts aéroport de Nice, gares, hôtels et déplacements d'affaires entre Cannes, Monaco et Saint-Tropez. Réservation en 2 minutes, tarif garanti avant de monter à bord.",
    "hero.rating": "{avg}/5 — {count} avis vérifiés",
    "hero.badge1": "Prix fixe garanti", "hero.badge2": "Suivi de vol inclus",
    "services.overline": "Nos services", "services.title": "Pensé pour les voyageurs exigeants de la Riviera",
    "pricing.overline": "Tarifs transparents", "pricing.title": "Les trajets populaires, à prix fixes",
    "pricing.note": "Tout inclus : péages, bagages, attente et pancarte. Le prix affiché est le prix payé — même en plein Festival.",
    "pricing.berline": "Berline Executive", "pricing.van": "Van Premium (7 pl.)",
    "pricing.book": "Réserver ce trajet",
    "pricing.quote_pre": "Une autre destination, un trajet sur mesure ?",
    "pricing.quote_link": "Demandez un devis gratuit — réponse sous 2 h",
    "fleet.overline": "La flotte", "fleet.title": "Deux véhicules, un même niveau d'exigence",
    "banner.overline": "L'expérience CabNow",
    "banner.title": "La Riviera se vit mieux quand on ne conduit pas.",
    "reviews.overline": "Avis clients", "reviews.title": "Ils ont voyagé avec CabNow",
    "reviews.collected": "{count} avis collectés après course",
    "reviews.empty": "Les premiers avis seront publiés ici après les prochaines courses.",
    "reviews.google": "Voir nos avis sur Google",
    "faq.overline": "Questions fréquentes", "faq.title": "Tout savoir avant de réserver",
    "cta.overline": "Départ immédiat ou programmé", "cta.title": "Votre chauffeur vous attend.",
    "cta.text": "Réservation en 2 minutes, confirmation immédiate par email, prix fixe garanti.",
    "cta.book": "Réserver maintenant",
    "cta.trust1": "Annulation gratuite jusqu'à 24 h avant",
    "cta.trust2": "Paiement en ligne, CB ou espèces à bord", "cta.trust3": "Aéroports, gares & hôtels",
    "footer.blurb": "Chauffeur privé d'exception sur la Côte d'Azur. Ponctualité absolue, prix fixes garantis, confort cinq étoiles.",
    "footer.dest_title": "Destinations", "footer.contact_title": "Contact",
    "footer.avail_title": "Disponibilité", "footer.avail1": "7 jours sur 7 — 24 h / 24",
    "footer.avail2": "Sur réservation, y compris vols de nuit et trains matinaux.",
    "footer.book": "Réserver une course",
    "footer.rights": "© 2026 CabNow — Tous droits réservés",
    "footer.legal": "Mentions légales · CGV · Confidentialité",
    "common.back_home": "Retour à l'accueil", "common.back": "Retour", "common.continue": "Continuer",
    "booking.steps": ["Itinéraire", "Véhicule", "Coordonnées", "Paiement"],
    "booking.steps_devis": ["Itinéraire", "Coordonnées"],
    "booking.it_title": "Votre itinéraire",
    "booking.it_sub": "Prix fixe calculé instantanément pour les destinations populaires.",
    "booking.custom_option": "Autre adresse — devis sur mesure",
    "booking.custom_pickup_ph": "Adresse exacte de prise en charge",
    "booking.custom_dropoff_ph": "Adresse exacte de destination",
    "booking.passengers": "Passagers", "booking.luggage": "Bagages",
    "booking.flight_label": "N° de vol ou train (optionnel)",
    "booking.flight_ph": "ex. AF7700 — suivi en temps réel",
    "booking.flight_required_airport": "N° de vol — obligatoire (suivi en temps réel)",
    "booking.flight_required_station": "N° de train — obligatoire",
    "booking.err_flight": "Le numéro de vol est obligatoire pour une prise en charge à l'aéroport.",
    "booking.err_train": "Le numéro de train est obligatoire pour une prise en charge à la gare.",
    "booking.child_seat": "Siège enfant / rehausseur (gratuit)",
    "booking.see_price": "Voir le prix fixe",
    "booking.veh_title": "Choisissez votre véhicule",
    "booking.all_included": "prix fixe, tout inclus",
    "booking.contact_title": "Vos coordonnées",
    "booking.contact_sub": "Confirmation immédiate par email — aucun compte à créer.",
    "booking.name_label": "Nom complet", "booking.name_ph": "Nom du passager principal",
    "booking.phone_label": "Téléphone mobile",
    "booking.notes_label": "Notes pour le chauffeur (optionnel)",
    "booking.notes_ph": "Pancarte spéciale, arrêt intermédiaire, code d'accès résidence…",
    "booking.send_quote": "Envoyer ma demande de devis",
    "booking.pay_title": "Paiement",
    "booking.pay_sub": "Trois options, même prix fixe garanti.",
    "booking.online_title": "Carte bancaire en ligne",
    "booking.online_text": "Paiement sécurisé — course réglée à l'avance, zéro souci à l'arrivée.",
    "booking.onboard_card_title": "Carte bleue à bord",
    "booking.onboard_card_text": "Terminal CB du chauffeur — réglé à l'arrivée, sans prépaiement.",
    "booking.onboard_cash_title": "Espèces à bord",
    "booking.onboard_cash_text": "Règlement en espèces en fin de course, sans prépaiement.",
    "booking.summary": "Récapitulatif", "booking.s_route": "Trajet", "booking.s_datetime": "Date & heure",
    "booking.s_vehicle": "Véhicule", "booking.s_passengers": "Passagers",
    "booking.s_luggage": "bagage(s)", "booking.s_at": "à",
    "booking.s_total": "Total — prix fixe garanti",
    "booking.cancel_note": "Annulation gratuite jusqu'à 24 h avant la prise en charge.",
    "booking.pay_confirm": "Payer et confirmer", "booking.confirm_booking": "Confirmer la réservation",
    "booking.choose_payment": "Choisir le paiement",
    "booking.devis_title": "Demande envoyée",
    "booking.devis_text": "Merci {name} — votre demande de devis pour {from} → {to} est entre de bonnes mains. Réponse garantie sous 2 heures par email, avec un prix fixe.",
    "booking.err_datetime": "Choisissez une date et une heure.",
    "booking.err_addresses": "Indiquez les adresses de départ et d'arrivée.",
    "booking.err_locations": "Choisissez deux lieux différents.",
    "booking.err_name": "Indiquez votre nom.",
    "booking.err_email": "Indiquez un email valide.",
    "booking.err_phone": "Indiquez un numéro de téléphone.",
    "booking.tag_business": "Le choix business", "booking.tag_family": "Le choix famille",
    "booking.berline_cap": "3 passagers · 3 bagages", "booking.van_cap": "7 passagers · 8 bagages",
    "confirmation.notfound_title": "Réservation introuvable",
    "confirmation.notfound_text": "Vérifiez le lien reçu par email ou contactez-nous au +33 6 61 29 75 99.",
    "confirmation.confirmed": "Réservation confirmée", "confirmation.pending": "Paiement en attente",
    "confirmation.reference": "Référence",
    "confirmation.r_pickup": "Prise en charge", "confirmation.r_dropoff": "Destination",
    "confirmation.r_date": "Date", "confirmation.r_time": "Heure",
    "confirmation.r_vehicle": "Véhicule", "confirmation.r_passengers": "Passagers",
    "confirmation.r_fare": "Tarif — prix fixe",
    "confirmation.r_voucher": "Bon de transport",
    "confirmation.voucher_link": "Voir mon bon de transport",
    "confirmation.email_onboard_card": "Un email de confirmation avec votre bon de transport vient d'être envoyé à {email}. Vous réglerez {price} € par carte bleue à bord (terminal CB du chauffeur).",
    "confirmation.email_onboard_cash": "Un email de confirmation avec votre bon de transport vient d'être envoyé à {email}. Vous réglerez {price} € en espèces à bord.",
    "confirmation.email_online": "Votre paiement est confirmé. Un email récapitulatif avec votre bon de transport a été envoyé à {email}.",
    "bon.title": "Bon de transport",
    "bon.issued": "Émis le {date}",
    "bon.company": "Société", "bon.client": "Client",
    "bon.ride_title": "Détails de la course",
    "bon.fare": "Tarif TTC — prix fixe garanti",
    "bon.pay_online": "Payé en ligne par carte", "bon.pay_card": "Carte bleue à bord (terminal CB)",
    "bon.pay_cash": "Espèces à bord",
    "bon.legal": "Document émis électroniquement par CabNow, chauffeur privé VTC — Cannes, Alpes-Maritimes. À présenter au chauffeur.",
    "bon.print": "Imprimer / enregistrer",
    "cancel.title": "Annuler ma réservation",
    "cancel.subtitle": "Annulation gratuite jusqu'à 24 h avant la prise en charge.",
    "cancel.hours_left": "Votre course est prévue dans {hours} h.",
    "cancel.confirm": "Confirmer l'annulation",
    "cancel.keep": "Garder ma réservation",
    "cancel.warning": "Cette action est définitive.",
    "cancel.already": "Cette réservation est déjà annulée.",
    "cancel.too_late": "L'annulation en ligne n'est plus possible à moins de 24 h de la course. Appelez-nous au +33 6 61 29 75 99.",
    "cancel.done_title": "Réservation annulée",
    "cancel.done_text": "Votre réservation a bien été annulée. Un email de confirmation vous a été envoyé.",
    "cancel.refund": "Votre paiement de {price} € sera remboursé sur votre carte sous 5 à 10 jours ouvrés.",
    "payment.verifying_title": "Vérification du paiement…",
    "payment.verifying_text": "Quelques secondes suffisent.",
    "payment.success_title": "Paiement confirmé",
    "payment.success_text": "Votre course est réservée et réglée. La confirmation arrive dans votre boîte mail.",
    "payment.view_booking": "Voir ma réservation",
    "payment.cancelled_title": "Paiement annulé",
    "payment.cancelled_text": "Aucun montant n'a été débité. Vous pouvez reprendre votre réservation quand vous le souhaitez.",
    "payment.timeout_title": "Vérification en cours",
    "payment.timeout_text": "Si vous avez bien payé, votre confirmation arrivera par email dans quelques instants.",
    "payment.retry": "Refaire une réservation",
    "review.invalid_title": "Lien invalide",
    "review.overline": "Votre avis compte",
    "review.title": "Comment s'est passée votre course ?",
    "review.not_completed": "Votre course n'est pas encore terminée — vous pourrez déposer votre avis juste après l'arrivée.",
    "review.already": "Merci, votre avis a déjà été enregistré pour cette course.",
    "review.global": "Note globale",
    "review.crit_punctuality": "Ponctualité", "review.crit_comfort": "Confort du véhicule",
    "review.crit_courtesy": "Courtoisie du chauffeur",
    "review.name_label": "Votre nom (affiché avec l'avis)",
    "review.comment_label": "Votre commentaire",
    "review.comment_ph": "Ponctualité, conduite, propreté… dites-nous tout.",
    "review.submit": "Publier mon avis",
    "review.thanks_title": "Merci {name} !",
    "review.thanks_text": "Votre avis est publié sur notre site et aide d'autres voyageurs à choisir CabNow.",
    "review.google_cta": "Partager aussi sur Google — ça nous aide énormément",
    "review.err_name": "Indiquez votre nom ou prénom.",
    "review.err_comment": "Quelques mots sur votre course nous aident beaucoup.",
    "chat.status": "Réponse immédiate, 7j/7",
    "chat.greeting": "Bonjour ! Je réponds à toutes vos questions sur nos transferts : prix fixes, véhicules, horaires, prise en charge aéroport… Comment puis-je vous aider ?",
    "chat.placeholder": "Votre question…",
    "chat.disclaimer": "Assistant IA CabNow — prix définitifs confirmés à la réservation",
    "chat.error": "Désolé, une erreur est survenue. Appelez-nous au +33 6 61 29 75 99 — réponse immédiate.",
    "nav.blog": "Blog",
    "blog.overline": "Le journal CabNow",
    "blog.title": "Guides & conseils Riviera",
    "blog.subtitle": "Transferts, prix, bonnes adresses : nos chauffeurs partagent leurs conseils pour voyager sereinement sur la Côte d'Azur.",
    "blog.read": "Lire l'article", "blog.back": "Tous les articles",
    "blog.empty": "Les premiers articles arrivent bientôt.",
    "blog.published_on": "Publié le {date}",
    "blog.related": "À lire aussi",
    "footer.mougins_link": "Chauffeur privé Mougins",
    "mougins.meta_title": "Chauffeur Privé Mougins — VTC & Transfert Aéroport Nice | CabNow",
    "mougins.meta_desc": "Chauffeur privé à Mougins : transferts aéroport Nice, Cannes, Sophia Antipolis et Grasse. Prix fixe garanti, accueil pancarte, réservation en 2 min — l'alternative au taxi.",
    "mougins.overline": "Chauffeur privé — Mougins & alentours",
    "mougins.h1": "Chauffeur privé à Mougins",
    "mougins.subtitle": "Votre VTC à Mougins pour tous vos trajets : transferts aéroport de Nice, Cannes et la Croisette, Sophia Antipolis, Grasse. Prix fixe garanti à la réservation — l'alternative sereine au taxi.",
    "mougins.badge1": "Prix fixe garanti", "mougins.badge2": "Prise en charge à votre porte",
    "mougins.dest_overline": "Au départ de Mougins",
    "mougins.dest_title": "Vos destinations, à prix fixe",
    "mougins.from_price": "dès {price} € en berline",
    "mougins.book_route": "Réserver",
    "mougins.why_overline": "Pourquoi CabNow",
    "mougins.why_title": "L'alternative au taxi à Mougins",
    "mougins.faq_overline": "Questions fréquentes",
    "mougins.faq_title": "Chauffeur privé à Mougins : vos questions",
    "booking.service_transfer": "Transfert",
    "booking.service_hourly": "Mise à disposition",
    "booking.hours_label": "Durée souhaitée",
    "booking.hourly_hint": "Chauffeur dédié, itinéraire libre pendant toute la durée choisie (2 h minimum).",
    "booking.hourly_route": "Mise à disposition {hours} h — départ {from}",
    "booking.pickup_address_label": "Adresse exacte de prise en charge",
    "booking.dropoff_address_label": "Adresse exacte de destination",
    "booking.address_ph": "N°, rue, hôtel, résidence…",
    "booking.err_pickup_address": "Indiquez l'adresse exacte de prise en charge pour que le chauffeur vous trouve.",
    "booking.err_dropoff_address": "Indiquez l'adresse exacte de destination.",
    "booking.err_select_address": "Choisissez vos adresses dans les suggestions proposées (géolocalisation).",
    "booking.err_exact_address": "Entrez une adresse précise avec rue et numéro, choisie dans les suggestions (inutile pour un aéroport ou une gare).",
    "booking.exact_hint": "Précisez maintenant l'adresse exacte : n°, rue, hôtel, résidence…",
    "booking.child_seat_age": "Âge de l'enfant — le chauffeur apporte le siège adapté",
    "booking.seat_0_2": "0 – 2 ans", "booking.seat_sub_0_2": "Siège coque bébé",
    "booking.seat_3_7": "3 – 7 ans", "booking.seat_sub_3_7": "Siège enfant",
    "booking.seat_7plus": "7 ans et +", "booking.seat_sub_7plus": "Réhausseur",
    "booking.err_child_seat_age": "Précisez la tranche d'âge de l'enfant pour que le chauffeur apporte le siège adapté.",
    "booking.devis_subject_congres": "Demande entreprise / congrès : ",
    "booking.devis_subject_mariage": "Demande mariage / événement : ",
    "events.overline": "Entreprises & événements",
    "events.title": "Congrès, séminaires et célébrations",
    "events.subtitle": "Groupes, équipes, invités : nous organisons vos déplacements sur toute la Côte d'Azur, avec un interlocuteur unique et un devis gratuit sous 2 h.",
    "events.biz_title": "Congrès & séminaires d'entreprise",
    "events.biz_text": "Festival de Cannes, MIPIM, Cannes Lions, conférences à Monaco… Navettes de vos équipes et invités entre l'aéroport, les hôtels et le Palais des Festivals, avec coordination de plusieurs chauffeurs si nécessaire.",
    "events.wed_title": "Mariages & événements privés",
    "events.wed_text": "Un chauffeur à votre disposition pour le grand jour : trajets des mariés, navettes des invités, retours de fin de soirée. Berline executive ou van premium, horaires libres.",
    "events.cta": "Demander un devis gratuit",
    "events.note": "Réponse sous 2 h ouvrées — devis sans engagement.",
    "events.refs_overline": "Références événementielles",
    "events.refs_title": "Ils nous confient leurs grands événements",
    "events.refs_link": "Découvrir notre histoire",
    "footer.partners_link": "Partenaires & références",
    "partners.meta_title": "Partenaires & Références — CabNow, transport d'événements Côte d'Azur",
    "partners.meta_desc": "Festival de Cannes avec BMW, Cannes Lions, Madame Figaro, Grand Prix de Monaco, délégations diplomatiques : l'histoire et les références de CabNow, chauffeur privé à Cannes.",
    "partners.overline": "Notre histoire & nos références",
    "partners.h1": "Une confiance forgée sur les plus grands événements",
    "partners.subtitle": "Depuis Cannes, CabNow accompagne festivals, maisons de luxe, écuries et délégations diplomatiques. Voici les missions qui ont construit notre exigence.",
    "partners.cta_title": "Une agence, un événement, une délégation ?",
    "partners.cta_text": "Parlez-nous de votre projet : réponse et devis gratuit sous 2 h ouvrées.",
    "partners.cta_button": "Demander un devis événement",
    "home.blog_title": "Le journal CabNow",
    "home.blog_subtitle": "Guides prix, conseils aéroport et bonnes adresses signés par nos chauffeurs.",
    "chat.aria_open": "Ouvrir la conciergerie CabNow",
  },
  en: {
    "nav.services": "Services", "nav.pricing": "Pricing", "nav.fleet": "Fleet", "nav.reviews": "Reviews",
    "nav.contact": "Contact", "nav.book": "Book now",
    "widget.overline": "Express booking", "widget.title": "Your ride in 2 minutes",
    "widget.pickup": "Pick-up address", "widget.dropoff": "Destination address", "widget.date": "Date", "widget.time": "Time",
    "widget.submit": "See price & book",
    "widget.note": "Fixed price guaranteed before booking — no account, no commitment.",
    "widget.quote_link": "Other address? Free quote",
    "widget.err_locations": "Please choose two different locations.",
    "hero.overline": "Private chauffeur — Nice · Cannes · Monaco",
    "hero.l1": "Your private chauffeur,", "hero.l2": "on the French Riviera.", "hero.l3": "Fixed price. No waiting.",
    "hero.subtitle": "Nice airport transfers, train stations, hotels and business travel between Cannes, Monaco and Saint-Tropez. Book in 2 minutes, fare guaranteed before you step in.",
    "hero.rating": "{avg}/5 — {count} verified reviews",
    "hero.badge1": "Fixed price guaranteed", "hero.badge2": "Flight tracking included",
    "services.overline": "Our services", "services.title": "Designed for the Riviera's most demanding travellers",
    "pricing.overline": "Transparent pricing", "pricing.title": "Popular routes, fixed prices",
    "pricing.note": "All inclusive: tolls, luggage, waiting time and name sign. The price shown is the price you pay — even during the Festival.",
    "pricing.berline": "Executive Sedan", "pricing.van": "Premium Van (7 seats)",
    "pricing.book": "Book this ride",
    "pricing.quote_pre": "Another destination, a custom itinerary?",
    "pricing.quote_link": "Request a free quote — reply within 2 hours",
    "fleet.overline": "The fleet", "fleet.title": "Two vehicles, the same level of excellence",
    "banner.overline": "The CabNow experience",
    "banner.title": "The Riviera is best enjoyed when you're not driving.",
    "reviews.overline": "Client reviews", "reviews.title": "They travelled with CabNow",
    "reviews.collected": "{count} reviews collected after rides",
    "reviews.empty": "The first reviews will be published here after upcoming rides.",
    "reviews.google": "See our Google reviews",
    "faq.overline": "Frequently asked questions", "faq.title": "Everything to know before booking",
    "cta.overline": "Immediate or scheduled departure", "cta.title": "Your chauffeur is waiting.",
    "cta.text": "Book in 2 minutes, instant email confirmation, guaranteed fixed price.",
    "cta.book": "Book now",
    "cta.trust1": "Free cancellation up to 24 h before pick-up",
    "cta.trust2": "Pay online, by card or cash on board", "cta.trust3": "Airports, stations & hotels",
    "footer.blurb": "Exceptional private chauffeur on the French Riviera. Absolute punctuality, guaranteed fixed prices, five-star comfort.",
    "footer.dest_title": "Destinations", "footer.contact_title": "Contact",
    "footer.avail_title": "Availability", "footer.avail1": "7 days a week — 24/7",
    "footer.avail2": "By reservation, including night flights and early trains.",
    "footer.book": "Book a ride",
    "footer.rights": "© 2026 CabNow — All rights reserved",
    "footer.legal": "Legal notice · Terms · Privacy",
    "common.back_home": "Back to home", "common.back": "Back", "common.continue": "Continue",
    "booking.steps": ["Route", "Vehicle", "Your details", "Payment"],
    "booking.steps_devis": ["Route", "Your details"],
    "booking.it_title": "Your itinerary",
    "booking.it_sub": "Fixed price calculated instantly for popular destinations.",
    "booking.custom_option": "Other address — custom quote",
    "booking.custom_pickup_ph": "Exact pick-up address",
    "booking.custom_dropoff_ph": "Exact drop-off address",
    "booking.passengers": "Passengers", "booking.luggage": "Luggage",
    "booking.flight_label": "Flight or train number (optional)",
    "booking.flight_ph": "e.g. AF7700 — real-time tracking",
    "booking.flight_required_airport": "Flight number — required (real-time tracking)",
    "booking.flight_required_station": "Train number — required",
    "booking.err_flight": "A flight number is required for airport pick-ups.",
    "booking.err_train": "A train number is required for station pick-ups.",
    "booking.child_seat": "Child seat / booster (free)",
    "booking.see_price": "See fixed price",
    "booking.veh_title": "Choose your vehicle",
    "booking.all_included": "fixed price, all included",
    "booking.contact_title": "Your details",
    "booking.contact_sub": "Instant email confirmation — no account needed.",
    "booking.name_label": "Full name", "booking.name_ph": "Lead passenger name",
    "booking.phone_label": "Mobile phone",
    "booking.notes_label": "Notes for the chauffeur (optional)",
    "booking.notes_ph": "Custom name sign, intermediate stop, residence access code…",
    "booking.send_quote": "Send my quote request",
    "booking.pay_title": "Payment",
    "booking.pay_sub": "Three options, same guaranteed fixed price.",
    "booking.online_title": "Card payment online",
    "booking.online_text": "Secure payment — ride settled in advance, zero hassle on arrival.",
    "booking.onboard_card_title": "Card on board",
    "booking.onboard_card_text": "Chauffeur's card terminal — pay on arrival, no prepayment.",
    "booking.onboard_cash_title": "Cash on board",
    "booking.onboard_cash_text": "Pay in cash at the end of the ride, no prepayment.",
    "booking.summary": "Summary", "booking.s_route": "Route", "booking.s_datetime": "Date & time",
    "booking.s_vehicle": "Vehicle", "booking.s_passengers": "Passengers",
    "booking.s_luggage": "bag(s)", "booking.s_at": "at",
    "booking.s_total": "Total — guaranteed fixed price",
    "booking.cancel_note": "Free cancellation up to 24 h before pick-up.",
    "booking.pay_confirm": "Pay and confirm", "booking.confirm_booking": "Confirm booking",
    "booking.choose_payment": "Choose payment",
    "booking.devis_title": "Request sent",
    "booking.devis_text": "Thank you {name} — your quote request for {from} → {to} is in good hands. Guaranteed reply within 2 hours by email, with a fixed price.",
    "booking.err_datetime": "Please choose a date and a time.",
    "booking.err_addresses": "Please enter both pick-up and drop-off addresses.",
    "booking.err_locations": "Please choose two different locations.",
    "booking.err_name": "Please enter your name.",
    "booking.err_email": "Please enter a valid email.",
    "booking.err_phone": "Please enter a phone number.",
    "booking.tag_business": "The business choice", "booking.tag_family": "The family choice",
    "booking.berline_cap": "3 passengers · 3 bags", "booking.van_cap": "7 passengers · 8 bags",
    "confirmation.notfound_title": "Booking not found",
    "confirmation.notfound_text": "Check the link received by email or call us at +33 6 61 29 75 99.",
    "confirmation.confirmed": "Booking confirmed", "confirmation.pending": "Payment pending",
    "confirmation.reference": "Reference",
    "confirmation.r_pickup": "Pick-up", "confirmation.r_dropoff": "Destination",
    "confirmation.r_date": "Date", "confirmation.r_time": "Time",
    "confirmation.r_vehicle": "Vehicle", "confirmation.r_passengers": "Passengers",
    "confirmation.r_fare": "Fare — fixed price",
    "confirmation.r_voucher": "Transport voucher",
    "confirmation.voucher_link": "View my transport voucher",
    "confirmation.email_onboard_card": "A confirmation email with your transport voucher has just been sent to {email}. You will pay {price} € by card on board (chauffeur's card terminal).",
    "confirmation.email_onboard_cash": "A confirmation email with your transport voucher has just been sent to {email}. You will pay {price} € in cash on board.",
    "confirmation.email_online": "Your payment is confirmed. A summary email with your transport voucher has been sent to {email}.",
    "bon.title": "Transport voucher",
    "bon.issued": "Issued on {date}",
    "bon.company": "Company", "bon.client": "Client",
    "bon.ride_title": "Ride details",
    "bon.fare": "Fare incl. taxes — guaranteed fixed price",
    "bon.pay_online": "Paid online by card", "bon.pay_card": "Card on board (card terminal)",
    "bon.pay_cash": "Cash on board",
    "bon.legal": "Document issued electronically by CabNow, private chauffeur VTC — Cannes, Alpes-Maritimes. Show it to your chauffeur.",
    "bon.print": "Print / save",
    "cancel.title": "Cancel my booking",
    "cancel.subtitle": "Free cancellation up to 24 h before pick-up.",
    "cancel.hours_left": "Your ride is scheduled in {hours} h.",
    "cancel.confirm": "Confirm cancellation",
    "cancel.keep": "Keep my booking",
    "cancel.warning": "This action is final.",
    "cancel.already": "This booking is already cancelled.",
    "cancel.too_late": "Online cancellation is no longer possible within 24 h of the ride. Call us at +33 6 61 29 75 99.",
    "cancel.done_title": "Booking cancelled",
    "cancel.done_text": "Your booking has been cancelled. A confirmation email has been sent to you.",
    "cancel.refund": "Your payment of {price} € will be refunded to your card within 5 to 10 business days.",
    "payment.verifying_title": "Verifying payment…",
    "payment.verifying_text": "Just a few seconds.",
    "payment.success_title": "Payment confirmed",
    "payment.success_text": "Your ride is booked and paid. The confirmation is on its way to your inbox.",
    "payment.view_booking": "View my booking",
    "payment.cancelled_title": "Payment cancelled",
    "payment.cancelled_text": "No amount was charged. You can resume your booking whenever you like.",
    "payment.timeout_title": "Verification in progress",
    "payment.timeout_text": "If your payment went through, your confirmation will arrive by email shortly.",
    "payment.retry": "Make a new booking",
    "review.invalid_title": "Invalid link",
    "review.overline": "Your review matters",
    "review.title": "How was your ride?",
    "review.not_completed": "Your ride is not over yet — you can leave your review right after arrival.",
    "review.already": "Thank you, your review has already been recorded for this ride.",
    "review.global": "Overall rating",
    "review.crit_punctuality": "Punctuality", "review.crit_comfort": "Vehicle comfort",
    "review.crit_courtesy": "Chauffeur courtesy",
    "review.name_label": "Your name (shown with the review)",
    "review.comment_label": "Your comment",
    "review.comment_ph": "Punctuality, driving, cleanliness… tell us everything.",
    "review.submit": "Publish my review",
    "review.thanks_title": "Thank you {name}!",
    "review.thanks_text": "Your review is published on our site and helps other travellers choose CabNow.",
    "review.google_cta": "Also share on Google — it helps us enormously",
    "review.err_name": "Please enter your name or first name.",
    "review.err_comment": "A few words about your ride help us a lot.",
    "chat.status": "Instant reply, 7 days a week",
    "chat.greeting": "Hello! I can answer all your questions about our transfers: fixed prices, vehicles, schedules, airport pick-up… How can I help you?",
    "chat.placeholder": "Your question…",
    "chat.disclaimer": "CabNow AI assistant — final prices confirmed at booking",
    "chat.error": "Sorry, something went wrong. Call us at +33 6 61 29 75 99 — immediate answer.",
    "nav.blog": "Blog",
    "blog.overline": "The CabNow journal",
    "blog.title": "Riviera guides & tips",
    "blog.subtitle": "Transfers, prices, good addresses: our chauffeurs share their tips for travelling smoothly on the French Riviera.",
    "blog.read": "Read the article", "blog.back": "All articles",
    "blog.empty": "First articles coming soon.",
    "blog.published_on": "Published on {date}",
    "blog.related": "Read next",
    "footer.mougins_link": "Private driver in Mougins",
    "mougins.meta_title": "Private Driver in Mougins — VTC & Nice Airport Transfers | CabNow",
    "mougins.meta_desc": "Private driver in Mougins: Nice airport transfers, Cannes, Sophia Antipolis and Grasse. Guaranteed fixed price, name-sign welcome, 2-minute booking — the taxi alternative.",
    "mougins.overline": "Private chauffeur — Mougins & surroundings",
    "mougins.h1": "Private driver in Mougins",
    "mougins.subtitle": "Your VTC in Mougins for every journey: Nice airport transfers, Cannes and the Croisette, Sophia Antipolis, Grasse. Fixed price guaranteed at booking — the relaxed alternative to a taxi.",
    "mougins.badge1": "Guaranteed fixed price", "mougins.badge2": "Door-to-door pick-up",
    "mougins.dest_overline": "From Mougins",
    "mougins.dest_title": "Your destinations, at fixed prices",
    "mougins.from_price": "from €{price} by sedan",
    "mougins.book_route": "Book",
    "mougins.why_overline": "Why CabNow",
    "mougins.why_title": "The alternative to a taxi in Mougins",
    "mougins.faq_overline": "Frequently asked questions",
    "mougins.faq_title": "Private driver in Mougins: your questions",
    "booking.service_transfer": "Transfer",
    "booking.service_hourly": "Hourly hire",
    "booking.hours_label": "Desired duration",
    "booking.hourly_hint": "Dedicated chauffeur, free itinerary for the whole duration (2 hrs minimum).",
    "booking.hourly_route": "Hourly hire {hours} hrs — from {from}",
    "booking.pickup_address_label": "Exact pick-up address",
    "booking.dropoff_address_label": "Exact destination address",
    "booking.address_ph": "Street no., street, hotel, residence…",
    "booking.err_pickup_address": "Please enter the exact pick-up address so your chauffeur can find you.",
    "booking.err_dropoff_address": "Please enter the exact destination address.",
    "booking.err_select_address": "Please choose your addresses from the suggestions (geolocation).",
    "booking.err_exact_address": "Please enter a precise address with street and number, chosen from the suggestions (not needed for an airport or station).",
    "booking.exact_hint": "Now refine the exact address: no., street, hotel, residence…",
    "booking.child_seat_age": "Child's age — your chauffeur brings the right seat",
    "booking.seat_0_2": "0 – 2 yrs", "booking.seat_sub_0_2": "Baby carrier seat",
    "booking.seat_3_7": "3 – 7 yrs", "booking.seat_sub_3_7": "Child seat",
    "booking.seat_7plus": "7 yrs and over", "booking.seat_sub_7plus": "Booster seat",
    "booking.err_child_seat_age": "Please tell us the child's age bracket so your chauffeur brings the right seat.",
    "booking.devis_subject_congres": "Corporate / conference request: ",
    "booking.devis_subject_mariage": "Wedding / event request: ",
    "events.overline": "Corporate & events",
    "events.title": "Conferences, seminars and celebrations",
    "events.subtitle": "Groups, teams, guests: we organise your transport across the French Riviera, with a single point of contact and a free quote within 2 hours.",
    "events.biz_title": "Conferences & corporate seminars",
    "events.biz_text": "Cannes Film Festival, MIPIM, Cannes Lions, conferences in Monaco… Shuttles for your teams and guests between the airport, hotels and the Palais des Festivals, with several chauffeurs coordinated when needed.",
    "events.wed_title": "Weddings & private events",
    "events.wed_text": "A chauffeur at your disposal for the big day: journeys for the couple, guest shuttles, late-night returns. Executive sedan or premium van, flexible hours.",
    "events.cta": "Request a free quote",
    "events.note": "Reply within 2 business hours — no-obligation quote.",
    "events.refs_overline": "Event references",
    "events.refs_title": "They trust us with their biggest events",
    "events.refs_link": "Discover our story",
    "footer.partners_link": "Partners & references",
    "partners.meta_title": "Partners & References — CabNow, event transport on the French Riviera",
    "partners.meta_desc": "Cannes Film Festival with BMW, Cannes Lions, Madame Figaro, Monaco Grand Prix, diplomatic delegations: the story and references of CabNow, private chauffeur in Cannes.",
    "partners.overline": "Our story & references",
    "partners.h1": "Trust forged on the world's biggest events",
    "partners.subtitle": "From Cannes, CabNow serves festivals, luxury houses, racing teams and diplomatic delegations. These are the missions that built our standards.",
    "partners.cta_title": "An agency, an event, a delegation?",
    "partners.cta_text": "Tell us about your project: reply and free quote within 2 business hours.",
    "partners.cta_button": "Request an event quote",
    "home.blog_title": "From the CabNow journal",
    "home.blog_subtitle": "Price guides, airport tips and good addresses by our chauffeurs.",
    "chat.aria_open": "Open the CabNow concierge",
  },
};

const arrays = {
  fr: {
    "services.items": [
      { title: "Aéroports & Gares", text: "Accueil avec pancarte, suivi de vol en temps réel et 1 h d'attente offerte. Aéroport Nice, gares de Cannes et Nice-Ville." },
      { title: "Affaires & Roadshows", text: "Wi-Fi à bord, discrétion totale, facturation entreprise mensuelle pour vos salons — MIPIM, Cannes Lions, Festival." },
      { title: "Hôtels & Conciergerie", text: "Partenaire des palaces de la Croisette et des conciergeries exigeantes. Prise en charge au pied de votre hôtel." },
      { title: "Mise à disposition", text: "Un chauffeur dédié à l'heure — 80 €/h en berline, 100 €/h en van (min. 2 h), réservable en ligne — ou à la journée : shopping, dîners, escapades." },
    ],
    "fleet.cards": [
      { id: "berline", name: "Berline Executive", tag: "Le choix business",
        desc: "Berline récente haut de gamme — l'élégance discrète pour vos transferts aéroport et rendez-vous d'affaires.",
        specs: ["3 passagers", "3 bagages", "Wi-Fi & chargeurs", "Siège enfant sur demande"] },
      { id: "van", name: "Van Premium", tag: "Le choix famille",
        desc: "Habitacle spacieux et climatisation individuelle — familles, groupes et équipes avec bagages volumineux.",
        specs: ["7 passagers", "8 bagages", "Wi-Fi & chargeurs", "Sièges enfants inclus"] },
    ],
    "faq.items": [
      { q: "Comment se passe la prise en charge à l'aéroport de Nice ?",
        a: "Votre chauffeur suit votre vol en temps réel et vous attend dans le hall des arrivées avec une pancarte à votre nom. Une heure d'attente est offerte en cas de retard." },
      { q: "Le prix affiché peut-il changer ?",
        a: "Non. Le tarif est fixe et garanti à la réservation — péages, bagages et attente inclus, même pendant le Festival de Cannes ou le Grand Prix de Monaco." },
      { q: "Quels moyens de paiement acceptez-vous ?",
        a: "Carte bancaire en ligne au moment de la réservation, ou directement à bord auprès du chauffeur (carte bleue ou espèces). Un bon de transport vous est envoyé par email après la réservation." },
      { q: "Puis-je réserver pour quelqu'un d'autre ?",
        a: "Bien sûr — assistants, concierges et offices de tourisme réservent régulièrement pour leurs clients. Indiquez simplement le nom du passager dans les notes." },
    ],
    "mougins.why_items": [
      { title: "Prix fixe, confirmé à l'avance", text: "Contrairement au taxi, le tarif est calculé et bloqué à la réservation — péages, bagages et attente inclus. Aucune surprise, même en pleine saison." },
      { title: "Un chauffeur qui connaît Mougins", text: "Vieux village, golfs, domaines et résidences : prise en charge à votre porte, itinéraires malins vers Cannes, Valbonne et Sophia Antipolis." },
      { title: "Transferts aéroport sans stress", text: "Suivi de vol en temps réel, accueil avec pancarte et une heure d'attente offerte à l'aéroport Nice Côte d'Azur." },
      { title: "Paiement comme vous voulez", text: "Carte bancaire en ligne, ou directement à bord en CB ou espèces. Bon de transport envoyé par email — annulation gratuite jusqu'à 24 h avant." },
    ],
    "mougins.faq_items": [
      { q: "Quel est le prix d'une course au départ de Mougins ?",
        a: "Le tarif s'affiche instantanément dans notre module de réservation : il est fixe et garanti, péages et bagages inclus. Vous connaissez le montant exact avant de monter à bord." },
      { q: "Faites-vous les transferts entre l'aéroport de Nice et Mougins ?",
        a: "Oui, c'est l'un de nos trajets les plus fréquents — environ 30 minutes par l'A8. Votre chauffeur suit votre vol et vous attend avec une pancarte à votre nom." },
      { q: "Quelle différence entre un VTC et un taxi à Mougins ?",
        a: "Un VTC se réserve à l'avance, à prix fixe, avec un véhicule et un chauffeur dédiés. En saison ou pendant les festivals, c'est la garantie de ne jamais attendre." },
      { q: "Puis-je payer à bord ?",
        a: "Oui — carte bleue ou espèces auprès du chauffeur. Vous pouvez aussi payer en ligne par carte au moment de la réservation." },
      { q: "Puis-je annuler ma réservation ?",
        a: "Oui, gratuitement jusqu'à 24 heures avant la prise en charge, depuis le lien reçu dans votre email de confirmation. Au-delà, contactez-nous." },
    ],
    "events.refs_items": [
      "Festival de Cannes — partenaire transport avec BMW (4 ans)",
      "Cannes Lions",
      "Madame Figaro — Arles 2026",
      "Grand Prix de Monaco — clients & écuries (3 ans)",
    ],
    "partners.missions": [
      { year: "4 ans", title: "Festival de Cannes × BMW", text: "Partenaire transport aux côtés de BMW, partenaire officiel du Festival : navettes de talents et d'invités, véhicules pour la montée des marches, coordination jour et nuit pendant toute la quinzaine." },
      { year: "Éditions multiples", title: "Cannes Lions", text: "Transferts de délégations internationales et d'équipes créatives pendant le festival mondial de la publicité, entre aéroport, hôtels et Palais des Festivals." },
      { year: "2026", title: "Madame Figaro — Arles", text: "Mission en partenariat avec Madame Figaro : transport des invités et des équipes pour l'événement arlésien, avec la même exigence de ponctualité et de discrétion." },
      { year: "3 saisons", title: "Grand Prix de Monaco", text: "Clients privés et écuries accompagnés pendant trois saisons : liaisons circuit, hôtels et héliport, plannings resserrés et changements de dernière minute absorbés sans friction." },
      { year: "Protocole", title: "Délégations diplomatiques", text: "Missions pour des délégations diplomatiques en conférence et pour les séjours du corps diplomatique sur la Côte d'Azur : discrétion absolue, chauffeurs briefés, coordination sécurisée." },
    ],
    "partners.values": [
      { title: "Discrétion", text: "Confidentialité totale et chauffeurs briefés protocole, pour personnalités et délégations." },
      { title: "Ponctualité", text: "Chaque trajet est anticipé, suivi et doublé d'un plan B." },
      { title: "Coordination", text: "Un interlocuteur unique, plusieurs chauffeurs mobilisés si nécessaire." },
    ],
    "chat.suggestions": [
      "Quel prix pour l'aéroport de Nice → Cannes ?",
      "Berline ou van pour 5 personnes ?",
      "Mon vol arrive à 23h, c'est possible ?",
    ],
  },
  en: {
    "services.items": [
      { title: "Airports & Stations", text: "Name-sign welcome, real-time flight tracking and 1 hour of free waiting. Nice airport, Cannes and Nice-Ville stations." },
      { title: "Business & Roadshows", text: "On-board Wi-Fi, total discretion, monthly corporate billing for your trade shows — MIPIM, Cannes Lions, the Festival." },
      { title: "Hotels & Concierge", text: "Partner of the Croisette palaces and the most demanding concierge desks. Pick-up at your hotel door." },
      { title: "Hourly hire", text: "A dedicated chauffeur by the hour — €80/hr by sedan, €100/hr by van (min. 2 hrs), bookable online — or full day: shopping, dinners, getaways." },
    ],
    "fleet.cards": [
      { id: "berline", name: "Executive Sedan", tag: "The business choice",
        desc: "Recent high-end sedan — discreet elegance for your airport transfers and business meetings.",
        specs: ["3 passengers", "3 bags", "Wi-Fi & chargers", "Child seat on request"] },
      { id: "van", name: "Premium Van", tag: "The family choice",
        desc: "Spacious cabin and individual climate control — families, groups and teams with bulky luggage.",
        specs: ["7 passengers", "8 bags", "Wi-Fi & chargers", "Child seats included"] },
    ],
    "faq.items": [
      { q: "How does pick-up work at Nice airport?",
        a: "Your chauffeur tracks your flight in real time and waits in the arrivals hall with a sign bearing your name. One hour of waiting is offered in case of delay." },
      { q: "Can the displayed price change?",
        a: "No. The fare is fixed and guaranteed at booking — tolls, luggage and waiting included, even during the Cannes Film Festival or the Monaco Grand Prix." },
      { q: "Which payment methods do you accept?",
        a: "Card online at booking time, or directly on board with the chauffeur (card or cash). A transport voucher is emailed to you after booking." },
      { q: "Can I book for someone else?",
        a: "Of course — assistants, concierges and tourist offices regularly book for their clients. Simply enter the passenger's name in the notes." },
    ],
    "mougins.why_items": [
      { title: "Fixed price, confirmed in advance", text: "Unlike a taxi, the fare is calculated and locked at booking — tolls, luggage and waiting included. No surprises, even in high season." },
      { title: "A chauffeur who knows Mougins", text: "Old village, golf courses, estates and private residences: pick-up at your door, smart routes to Cannes, Valbonne and Sophia Antipolis." },
      { title: "Stress-free airport transfers", text: "Real-time flight tracking, name-sign welcome and one hour of free waiting at Nice Côte d'Azur airport." },
      { title: "Pay the way you want", text: "By card online, or on board by card or cash. Transport voucher emailed after booking — free cancellation up to 24 hours ahead." },
    ],
    "mougins.faq_items": [
      { q: "How much is a ride from Mougins?",
        a: "The fare appears instantly in our booking module: it is fixed and guaranteed, tolls and luggage included. You know the exact amount before getting on board." },
      { q: "Do you run transfers between Nice airport and Mougins?",
        a: "Yes, it is one of our most frequent journeys — around 30 minutes via the A8. Your chauffeur tracks your flight and waits with a sign bearing your name." },
      { q: "What is the difference between a VTC and a taxi in Mougins?",
        a: "A VTC is booked in advance, at a fixed price, with a dedicated car and driver. In season or during festivals, it is the guarantee of never waiting." },
      { q: "Can I pay on board?",
        a: "Yes — by card or cash with the chauffeur. You can also pay online by card when booking." },
      { q: "Can I cancel my booking?",
        a: "Yes, free of charge up to 24 hours before pick-up, from the link in your confirmation email. After that, just contact us." },
    ],
    "events.refs_items": [
      "Cannes Film Festival — transport partner with BMW (4 years)",
      "Cannes Lions",
      "Madame Figaro — Arles 2026",
      "Monaco Grand Prix — clients & racing teams (3 years)",
    ],
    "partners.missions": [
      { year: "4 years", title: "Cannes Film Festival × BMW", text: "Transport partner alongside BMW, official partner of the Festival: talent and guest shuttles, vehicles for the red-carpet stairs, day-and-night coordination throughout the fortnight." },
      { year: "Multiple editions", title: "Cannes Lions", text: "Transfers for international delegations and creative teams during the world festival of advertising, between the airport, hotels and the Palais des Festivals." },
      { year: "2026", title: "Madame Figaro — Arles", text: "A mission in partnership with Madame Figaro: transporting guests and crews for the Arles event, with the same standards of punctuality and discretion." },
      { year: "3 seasons", title: "Monaco Grand Prix", text: "Private clients and racing teams supported for three seasons: circuit, hotel and heliport shuttles, tight schedules and last-minute changes absorbed seamlessly." },
      { year: "Protocol", title: "Diplomatic delegations", text: "Missions for diplomatic delegations attending conferences and for diplomatic corps stays on the French Riviera: absolute discretion, briefed chauffeurs, secure coordination." },
    ],
    "partners.values": [
      { title: "Discretion", text: "Total confidentiality and protocol-briefed chauffeurs, for public figures and delegations." },
      { title: "Punctuality", text: "Every journey is anticipated, tracked and backed by a plan B." },
      { title: "Coordination", text: "One single point of contact, with several chauffeurs mobilised when needed." },
    ],
    "chat.suggestions": [
      "What price for Nice airport → Cannes?",
      "Sedan or van for 5 people?",
      "My flight lands at 11pm, is that possible?",
    ],
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("cabnow_lang") || "fr");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("cabnow_lang", l);
    setLangState(l);
  };

  const t = (key, vars) => {
    let s = translations[lang]?.[key] ?? translations.fr[key] ?? key;
    if (typeof s === "string" && vars) {
      Object.entries(vars).forEach(([k, v]) => {
        s = s.replaceAll(`{${k}}`, String(v));
      });
    }
    return s;
  };

  const ta = (key) => arrays[lang]?.[key] ?? arrays.fr[key] ?? [];

  return (
    <LangContext.Provider value={{ lang, setLang, t, ta }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
